import axios from 'axios';

export default {
    getTenantLogsCollection(tenantUUID: string, params: any = {}): Promise<any> {
        const pageSize = params.pageSize || 15;
        let requestURL = process.env.VUE_APP_BASCLOUD_MOBILE_LOGS_SERVER_URL + '/analytics/app/' + tenantUUID + '/logs?pageSize=' + pageSize;

        if (params.from?.length > 0) requestURL += '&from=' + encodeURIComponent(params.from);
        if (params.until?.length > 0) requestURL += '&until=' + encodeURIComponent(params.until);
        if (params.cursor?.length > 0) requestURL += '&pageAfter=' + encodeURIComponent(params.cursor);

        return axios.get(requestURL);
    },
    getUserLogsCollection(tenantUUID: string, userUUID: string, params: any = {}): Promise<any> {
        const pageSize = params.pageSize || 15;
        let requestURL = process.env.VUE_APP_BASCLOUD_MOBILE_LOGS_SERVER_URL + '/analytics/app/' + tenantUUID + '/' + userUUID + '/logs?pageSize=' + pageSize;

        if (params.from?.length > 0) requestURL += '&from=' + encodeURIComponent(params.from);
        if (params.until?.length > 0) requestURL += '&until=' + encodeURIComponent(params.until);
        if (params.cursor?.length > 0) requestURL += '&pageAfter=' + encodeURIComponent(params.cursor);

        return axios.get(requestURL);
    },
    getLatestVersion(slug: string): Promise<any> {
        return axios.get(process.env.VUE_APP_BASCLOUD_MOBILE_LOGS_SERVER_URL + '/analytics/app/version/' + slug.toLowerCase() + '/latest');
    },
}
